import Image from 'next/image'
import Link from 'next/link'
import { IoRocketOutline } from 'react-icons/io5'
import { LiaWalletSolid } from 'react-icons/lia'
import { LuGrid2X2Check, LuLayoutDashboard, LuUsersRound } from 'react-icons/lu'
import { TfiHeadphoneAlt } from 'react-icons/tfi'
import { VscTools } from 'react-icons/vsc'
import HRMS1Image from '/public/HRMS-Portals/hrms-ss-1.png'
import HRMS2Image from '/public/HRMS-Portals/hrms-ss-2.png'

const hrmsFeatures = [
    {
        id: 1,
        icon: LuLayoutDashboard,
        header: 'Employee Dashboard',
        list: [
            {
                id: 1,
                text: 'Check-in & Check-out system',
            },
            {
                id: 2,
                text: 'Centralized view of attendance, leaves and payroll',
            },
        ],
    },
    {
        id: 2,
        icon: IoRocketOutline,
        header: 'Recruitment & Onboarding',
        list: [
            {
                id: 1,
                text: 'Job Openings & Candidate Management',
            },
            {
                id: 2,
                text: 'Resume Shortlisting & Interview Scheduling',
            },
            {
                id: 3,
                text: 'Offer Letter Management & Task Assignments',
            },
        ],
    },
    {
        id: 3,
        icon: LuUsersRound,
        header: 'Employee Management',
        list: [
            {
                id: 1,
                text: 'Profile Management & Shift Requests',
            },
            {
                id: 2,
                text: 'Work Type Assignments (WFO/WFH)',
            },
            {
                id: 3,
                text: 'Organization Chart Generation',
            },
        ],
    },
    {
        id: 4,
        icon: LuGrid2X2Check,
        header: 'Attendance & Leave Tracking',
        list: [
            {
                id: 1,
                text: 'Attendance Validation & Approval',
            },
            {
                id: 2,
                text: 'Leave Requests & Allocation',
            },
        ],
    },
    {
        id: 5,
        icon: LiaWalletSolid,
        header: 'Payroll Management',
        list: [
            {
                id: 1,
                text: 'Auto-Generated & Manual Payslips',
            },
            {
                id: 2,
                text: 'Salary Deductions, Allowances & Reimbursements',
            },
        ],
    },
    {
        id: 6,
        icon: TfiHeadphoneAlt,
        header: 'Ticketing System',
        list: [
            {
                id: 1,
                text: 'Employee Support for Complaints & Requests',
            },
        ],
    },
    {
        id: 7,
        icon: VscTools,
        header: 'Portal Configuration',
        list: [
            {
                id: 1,
                text: 'Email Automation & Company Policies Management',
            },
        ],
    },
]

const ExperienceTheFuture = () => {
    return (
        <section className='flex flex-col gap-28 overflow-hidden py-24'>
            <div className='px-2 sm:px-10 xl:px-48'>
                <h2 className='text-center text-4xl font-bold md:text-5xl'>
                    Experience the Future of HR Management
                </h2>
                <div className='relative grid'>
                    <div className='absolute top-4 left-1/3 aspect-square w-[19px] rounded-full bg-[#FFDBDA] md:w-[42px]' />
                    <div className='absolute top-[30%] right-8 aspect-square w-[19px] rounded-full bg-[#FFDBDA] md:w-[51px]' />
                    <div className='absolute top-[55%] -right-10 aspect-square w-[19px] rounded-full bg-[#FFDBDA]' />
                    <div className='absolute bottom-0 left-0 aspect-square w-[19px] rounded-full bg-[#FFDBDA]' />
                    <div className='absolute top-[35%] -left-8 aspect-square w-[31px] rounded-full bg-[#ABD4EF]' />
                    <div className='absolute -bottom-[10%] -right-16 aspect-square w-[19px] rounded-full bg-[#ABD4EF]' />
                    <div className='absolute bottom-[10%] left-40 aspect-square w-[19px] rounded-full bg-[#A4E4C2] md:left-48 md:w-[33px]' />
                    <Image
                        src={HRMS1Image}
                        alt='HRMS Screen 1'
                        className='col-start-1 row-start-1 w-3/4 md:w-[calc(100%-10rem)] xl:w-[calc(100%-15rem)]'
                    />
                    <Image
                        src={HRMS2Image}
                        alt='HRMS Screen 2'
                        className='col-start-1 row-start-1 mt-[15%] w-3/4 self-center justify-self-end md:w-[calc(100%-10rem)] xl:w-[calc(100%-15rem)]'
                    />
                </div>
                <p className='mx-auto w-full text-center text-base font-semibold text-[#646569] md:w-2/3 md:text-xl'>
                    Get a first-hand look at our intuitive and powerful HRMS platform designed to
                    simplify workforce management effortlessly.
                </p>
                <div className='mt-10'>
                    <Link href='https://hrmsportals.com/' target='_blank' className='w-fit'>
                        <button className='mx-auto flex items-center gap-3 bg-[#FF3B38] py-2 px-4 font-semibold  transition-all duration-300 ease-out hover:scale-105 hover:bg-[#FF3B38]  text-white shadow-[2px_2px_12px_0px_#00000026]'>
                            <IoRocketOutline className='text-2xl' />
                            Get Started
                        </button>
                    </Link>
                </div>
            </div>
            <div>
                <h2 className='mx-auto text-center text-4xl font-bold md:text-5xl lg:w-7/12'>
                    <span className='text-[#FF3B38]'>Powerful Features</span> for a Streamlined HR
                    Experience
                </h2>
                <p className='mt-4 text-center font-semibold text-[#646569]'>
                    Experience a centralized, efficient and automated HR system designed for modern
                    workplaces.
                </p>
                <div className='mx-auto mt-8 flex flex-wrap justify-center gap-4 px-2 sm:px-10 md:gap-8'>
                    {hrmsFeatures.map((feature) => {
                        return (
                            <div
                                key={feature.id}
                                className='flex w-full flex-col gap-4 border-2 border-[#D2D2D2] bg-[#FFEAEA] p-5 sm:w-64 lg:w-80'>
                                <div className='w-fit rounded-md bg-[#FF3B3826] p-2 text-3xl'>
                                    {<feature.icon className='text-[#FF3B38]' />}
                                </div>
                                <div className='text-xl font-semibold text-[#FF3B38]'>
                                    {feature.header}
                                </div>
                                <ul className='flex list-disc flex-col gap-2 px-4 text-sm font-semibold text-[#7E7E7E]'>
                                    {feature.list.map((item) => (
                                        <li key={item.id}>{item.text}</li>
                                    ))}
                                </ul>
                            </div>
                        )
                    })}
                </div>
                <div className='mt-12'>
                    <Link href='https://hrmsportals.com/' target='_blank' className='w-fit'>
                        <button className='mx-auto flex items-center gap-3 bg-[#FF3B38] py-2 px-4 font-semibold  transition-all duration-300 ease-out hover:scale-105 hover:bg-[#FF3B38]  text-white shadow-[2px_2px_12px_0px_#00000026]'>
                            <IoRocketOutline className='text-2xl' />
                            Get Started
                        </button>
                    </Link>
                </div>
            </div>
        </section>
    )
}

export default ExperienceTheFuture
